/* STORE MODE — runtime (deferred)
   Cookies, modal, switchers, menu filtering em ambos modos, URL rewriting, MutationObserver.
*/
(function(){
  'use strict';
  var COOKIE='og_store_mode';
  var MAXAGE=2147483647;
  var SNEAKER_HANDLES=null;

  function getCookie(n){var m=document.cookie.match(new RegExp('(?:^|; )'+n+'=([^;]*)'));return m?decodeURIComponent(m[1]):null;}
  function setCookie(n,v){document.cookie=n+'='+encodeURIComponent(v)+'; Max-Age='+MAXAGE+'; Path=/; SameSite=Lax';}
  function lsGet(k){try{return localStorage.getItem(k);}catch(e){return null;}}
  function lsSet(k,v){try{localStorage.setItem(k,v);}catch(e){}}
  function html(){return document.documentElement;}
  function getMode(){
    var m=getCookie(COOKIE) || lsGet(COOKIE);
    if (m==='all') m='apparel';
    return m;
  }
  function tagForMode(mode){ return mode==='sneakers' ? 'sneaker' : 'apparel'; }
  function sneakerHandles(){
    if (SNEAKER_HANDLES) return SNEAKER_HANDLES;
    var s=html().getAttribute('data-sneaker-handles')||'';
    SNEAKER_HANDLES = s.split(',').map(function(x){return x.trim().toLowerCase();}).filter(Boolean);
    return SNEAKER_HANDLES;
  }
  function isSneakerHandle(h){
    return sneakerHandles().indexOf((h||'').toLowerCase())>=0;
  }
  function extractCollectionHandle(href){
    try {
      var u=new URL(href, location.origin);
      if (u.pathname.indexOf('/collections/')!==0) return null;
      var p=u.pathname.replace('/collections/','').split('/')[0].split('?')[0];
      return p.toLowerCase();
    } catch(e){return null;}
  }

  function applyMode(mode){
    if (mode==='all') mode='apparel';
    setCookie(COOKIE,mode);
    lsSet(COOKIE,mode);
    html().setAttribute('data-store-mode',mode);
    html().classList.remove('store-mode-apparel','store-mode-sneakers','store-mode-none','store-mode-all');
    html().classList.add('store-mode-'+mode);
    if (window.__smUpdateTriggerIcon) window.__smUpdateTriggerIcon(mode);
    hideModal();
    var path=location.pathname;
    var params=new URLSearchParams(location.search);
    if (mode==='sneakers'){
      if (path==='/'||path==='') params.set('view','sneakers');
      if (path.indexOf('/collections')===0) {
        params.set('view','sneakers');
        params.set('filter.p.tag','sneaker');
      }
      if (path==='/search') { params.set('filter.p.tag','sneaker'); params.set('type','product'); }
    } else {
      params.delete('view');
      if (path.indexOf('/collections/')===0) params.set('filter.p.tag','apparel');
      if (path==='/search') { params.set('filter.p.tag','apparel'); params.set('type','product'); }
    }
    var qs=params.toString();
    location.assign(path+(qs?'?'+qs:'')+location.hash);
  }

  function modalEl(){ return document.querySelector('[data-store-mode-modal]'); }
  function showModal(){
    var m=modalEl(); if (!m) return;
    m.style.display='flex';
    document.body.style.overflow='hidden';
  }
  function hideModal(){
    var m=modalEl(); if (!m) return;
    m.style.display='none';
    document.body.style.overflow='';
  }

  function maybeShowModal(){
    var mode=getMode();
    if (mode){ hideModal(); return; }
    var path=location.pathname;
    var isHome=(path==='/'||path==='');
    var isCollections=path.indexOf('/collections')===0;
    var isSearch=path==='/search';
    if (isHome||isCollections||isSearch){
      showModal();
    } else {
      hideModal();
    }
  }

  function wireModal(){
    var modal=modalEl();
    if (!modal) return;
    modal.addEventListener('click', function(e){
      var t=e.target.closest('[data-store-mode-pick]');
      if (!t) return;
      var pick=t.getAttribute('data-store-mode-pick');
      if (pick==='apparel'||pick==='all'||pick==='sneakers') applyMode(pick);
    });
  }

  function wireSwitchers(){
    document.querySelectorAll('[data-store-mode-switcher]').forEach(function(sw){
      if (sw.__wired) return; sw.__wired=true;
      sw.addEventListener('click', function(e){
        var t=e.target.closest('[data-store-mode-pick]');
        if (!t) return;
        var pick=t.getAttribute('data-store-mode-pick');
        if (!pick) return;
        if (pick==='all') pick='apparel';
        var cur=getMode();
        if (cur===pick) return;
        applyMode(pick);
      });
    });
  }

  function decorateAllCollectionLinks(root){
    root=root||document;
    root.querySelectorAll('a[href*="/collections/"]').forEach(function(a){
      if (a.__sm_decorated) return; a.__sm_decorated=true;
      var handle=extractCollectionHandle(a.href);
      if (!handle) return;
      var hide = isSneakerHandle(handle) ? 'apparel' : 'sneakers';
      var container = a.closest('li, .mmsp__nav-item, .mmsp__drawer-item, .mmsp__drawer-link, [class*="menu-item"]') || a;
      container.setAttribute('data-mode-hide-in-'+hide, 'true');
    });
  }

  function rewriteInternalLinks(){
    var mode=getMode(); if (!mode) return;
    var wantTag = tagForMode(mode);
    document.querySelectorAll('a[href]').forEach(function(a){
      try {
        var u=new URL(a.href, location.origin);
        if (u.origin !== location.origin) return;
        var p=u.pathname;
        var changed=false;
        if (p.indexOf('/collections/')===0 || p==='/collections' || p==='/search'){
          if (u.searchParams.get('filter.p.tag') !== wantTag){
            u.searchParams.set('filter.p.tag', wantTag);
            changed=true;
          }
          if (p==='/search' && u.searchParams.get('type') !== 'product'){
            u.searchParams.set('type','product'); changed=true;
          }
          if (mode==='sneakers' && (p==='/'||p===''||p.indexOf('/collections')===0) && u.searchParams.get('view')!=='sneakers'){
            u.searchParams.set('view','sneakers'); changed=true;
          }
          if (mode==='apparel' && u.searchParams.get('view')==='sneakers'){
            u.searchParams.delete('view'); changed=true;
          }
          if (changed) a.href = u.toString();
        }
      } catch(e){}
    });
  }

  function attachFormFilters(){
    var mode=getMode(); if (!mode) return;
    var wantTag = tagForMode(mode);
    document.querySelectorAll('form[action="/search"], form[action*="/search"]').forEach(function(f){
      ensureHidden(f,'filter.p.tag',wantTag);
      ensureHidden(f,'type','product');
    });
  }
  function ensureHidden(form,name,value){
    var existing=form.querySelector('input[name="'+name+'"]');
    if (existing){ existing.value=value; return; }
    var i=document.createElement('input'); i.type='hidden'; i.name=name; i.value=value; form.appendChild(i);
  }

  function filterCardsByTag(){
    var mode=getMode(); if (!mode) return;
    var wantTag = tagForMode(mode);
    document.querySelectorAll('[data-product-tags], [data-tags]').forEach(function(card){
      var raw=card.getAttribute('data-product-tags')||card.getAttribute('data-tags')||'';
      var tags=raw.split(',').map(function(s){return s.trim().toLowerCase();});
      if (tags.indexOf(wantTag)<0){
        card.setAttribute('data-store-mode-card-hide','1');
      } else {
        card.removeAttribute('data-store-mode-card-hide');
      }
    });
  }

  function injectFloatingPill(){
    if (document.body.classList.contains('template-checkout')) return;
    // Desktop floating (sutil, canto inferior direito)
    var SM_J='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" width="16" height="16"><path d="M8.5 4 4 6v4l3 1v9h10v-9l3-1V6l-4.5-2L14 6h-4l-1.5-2Z"/><path d="M9.5 4 12 6l2.5-2"/></svg>';
    var SM_S='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" width="16" height="16"><path d="M3 17v-3l3-1 4-3 3-3 2 1 1 3 5 3c1 .4 1.5 1 1.5 2v1H3Z"/><path d="M9 10c1 .6 2 1 3 1"/></svg>';
    var oldFloat=document.querySelector('.store-mode-switcher--floating');
    if (oldFloat) oldFloat.remove();
    if (true){
      var w=document.createElement('div');
      w.className='store-mode-switcher store-mode-switcher--floating';
      w.setAttribute('data-store-mode-switcher','');
      w.innerHTML='<span class="store-mode-switcher__label">Loja</span>'+
        '<div class="store-mode-switcher__track" role="group" aria-label="Selecionar loja">'+
          '<button type="button" class="store-mode-switcher__btn" data-store-mode-pick="apparel"><span class="store-mode-switcher__icon">'+SM_J+'</span><span class="store-mode-switcher__text">Vestuário</span></button>'+
          '<button type="button" class="store-mode-switcher__btn" data-store-mode-pick="sneakers"><span class="store-mode-switcher__icon">'+SM_S+'</span><span class="store-mode-switcher__text">Sneakers</span></button>'+
        '</div>';
      document.body.appendChild(w);
    }
    // Mobile edge trigger + drawer
    var SM_ICON_JERSEY='<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" style="display:block"><path d="M8.5 4 4 6v4l3 1v9h10v-9l3-1V6l-4.5-2L14 6h-4l-1.5-2Z"/><path d="M9.5 4 12 6l2.5-2"/></svg>';
    var SM_ICON_SHOE='<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" style="display:block"><path d="M3 17v-3l3-1 4-3 3-3 2 1 1 3 5 3c1 .4 1.5 1 1.5 2v1H3Z"/><path d="M9 10c1 .6 2 1 3 1"/></svg>';
    var SM_ICON_SWAP='<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" style="display:block"><path d="M7 7h12l-3-3M17 17H5l3 3"/></svg>';
    // Remove versão antiga (forçar refresh quando JS mudar)
    var oldTrig=document.querySelector('.store-mode-edge-trigger');
    var oldDr=document.querySelector('.store-mode-edge-drawer');
    if (oldTrig) oldTrig.remove();
    if (oldDr) oldDr.remove();
    if (true){
      var trig=document.createElement('button');
      trig.className='store-mode-edge-trigger';
      trig.setAttribute('aria-label','Trocar loja');
      var curMode=getMode();
      function iconFor(m){
        if (m==='apparel') return SM_ICON_JERSEY;
        if (m==='sneakers') return SM_ICON_SHOE;
        return SM_ICON_SWAP;
      }
      trig.innerHTML=iconFor(curMode);
      trig.setAttribute('data-mode',curMode||'none');
      // Expose pra applyMode atualizar o ícone após troca
      window.__smUpdateTriggerIcon = function(newMode){
        var t=document.querySelector('.store-mode-edge-trigger');
        if (!t) return;
        t.innerHTML=iconFor(newMode);
        t.setAttribute('data-mode',newMode||'none');
      };
      trig.addEventListener('click', function(){
        var dr=document.querySelector('.store-mode-edge-drawer');
        if (dr) dr.setAttribute('data-open','1');
      });
      document.body.appendChild(trig);

      var dr=document.createElement('div');
      dr.className='store-mode-edge-drawer';
      var mode=getMode()||'';
      dr.innerHTML='<div class="store-mode-edge-drawer__sheet">'+
        '<h3 class="store-mode-edge-drawer__title">Em qual loja você está?</h3>'+
        '<div class="store-mode-edge-drawer__opts">'+
          '<button class="store-mode-edge-drawer__opt" data-store-mode-pick="apparel"'+(mode==='apparel'?' data-active="1"':'')+'>'+
            '<span class="store-mode-edge-drawer__opt-icon">'+SM_ICON_JERSEY+'</span><span>Vestuário</span>'+
          '</button>'+
          '<button class="store-mode-edge-drawer__opt" data-store-mode-pick="sneakers"'+(mode==='sneakers'?' data-active="1"':'')+'>'+
            '<span class="store-mode-edge-drawer__opt-icon">'+SM_ICON_SHOE+'</span><span>Sneakers</span>'+
          '</button>'+
        '</div>'+
        '<button class="store-mode-edge-drawer__close">Fechar</button>'+
      '</div>';
      dr.addEventListener('click', function(e){
        if (e.target.classList.contains('store-mode-edge-drawer')) dr.removeAttribute('data-open');
        if (e.target.classList.contains('store-mode-edge-drawer__close')) dr.removeAttribute('data-open');
        var pick=e.target.closest('[data-store-mode-pick]');
        if (pick){
          var v=pick.getAttribute('data-store-mode-pick');
          if (v==='apparel'||v==='sneakers') applyMode(v);
        }
      });
      document.body.appendChild(dr);
    }
  }

  // Injeta itens de menu de sneakers nas listas existentes quando modo=sneakers
  // Resolve "sidebar mostra só vestuário" — adiciona links sneakers no fim dos menus
  var SNEAKER_MENU_ITEMS = [
    {title:'Jordan',       url:'/collections/jordan'},
    {title:'Nike',         url:'/collections/nike'},
    {title:'Yeezy',        url:'/collections/yeezy'},
    {title:'Adidas',       url:'/collections/adidas'},
    {title:'New Balance',  url:'/collections/new-balance'},
    {title:'Puma',         url:'/collections/puma'},
    {title:'Asics',        url:'/collections/asics'},
    {title:'Salomon',      url:'/collections/salomon'},
    {title:'Travis Scott', url:'/collections/travis-scott'},
    {title:'Off-White',    url:'/collections/off-white'},
    {title:'Corteiz',      url:'/collections/corteiz'},
    {title:'Stussy',       url:'/collections/stussy'},
    {title:'Dunk',         url:'/collections/dunk'},
    {title:'Air Max',      url:'/collections/air-max'},
    {title:'Jordan 1',     url:'/collections/jordan-1-high'},
    {title:'Samba',        url:'/collections/samba'},
    {title:'Air Force 1',  url:'/collections/air-force-1'},
    {title:'Trending',     url:'/collections/trending-sneakers'},
    {title:'Lançamentos',  url:'/collections/lancamentos'}
  ];
  function injectSneakerMenuItems(){
    if (getMode()!=='sneakers') return;
    // Mobile menu (sidebar drawer)
    var mobileLists = document.querySelectorAll('.mobile-menu__nav[data-type="menu"]');
    mobileLists.forEach(function(ul){
      if (ul.__sm_injected) return; ul.__sm_injected=true;
      SNEAKER_MENU_ITEMS.forEach(function(item){
        var li=document.createElement('li');
        li.className='mobile-menu__nav-item';
        li.setAttribute('data-sm-injected','1');
        li.innerHTML='<a href="'+item.url+'?filter.p.tag=sneaker&view=sneakers" class="mobile-menu__nav-link" data-type="menuitem">'+item.title+'</a>';
        ul.appendChild(li);
      });
    });
    // Desktop nav-panel / navigation-drawer
    var navLists = document.querySelectorAll('.panel__scroller ul, .menu-drawer__menu, .header__nav-list');
    navLists.forEach(function(ul){
      if (ul.__sm_injected) return; ul.__sm_injected=true;
      SNEAKER_MENU_ITEMS.forEach(function(item){
        var li=document.createElement('li');
        li.setAttribute('data-sm-injected','1');
        li.style.cssText='padding:8px 16px;';
        li.innerHTML='<a href="'+item.url+'?filter.p.tag=sneaker&view=sneakers" style="font-weight:600;color:inherit;text-decoration:none;display:block;">'+item.title+'</a>';
        ul.appendChild(li);
      });
    });
    // MMSP drawer (sports-group-nav)
    var mmspDrawers = document.querySelectorAll('.mmsp__drawer .mmsp__drawer-list, [id^="mmsp-drawer-"] ul, [id^="mmsp-drawer-"] .mmsp__drawer-leagues');
    mmspDrawers.forEach(function(ul){
      if (ul.__sm_injected) return; ul.__sm_injected=true;
      SNEAKER_MENU_ITEMS.forEach(function(item){
        var li=document.createElement('li');
        li.setAttribute('data-sm-injected','1');
        li.style.cssText='padding:10px 16px;border-bottom:1px solid rgba(0,0,0,.06);';
        li.innerHTML='<a href="'+item.url+'?filter.p.tag=sneaker&view=sneakers" style="font-weight:600;color:inherit;text-decoration:none;display:block;">'+item.title+'</a>';
        ul.appendChild(li);
      });
    });
  }

  function observeForLateMenus(){
    var obs=new MutationObserver(function(muts){
      var hadCollectionLink=false;
      muts.forEach(function(m){
        m.addedNodes.forEach(function(n){
          if (n.nodeType!==1) return;
          if (n.querySelector && n.querySelector('a[href*="/collections/"]')) hadCollectionLink=true;
          if (n.matches && n.matches('a[href*="/collections/"]')) hadCollectionLink=true;
        });
      });
      if (hadCollectionLink){
        decorateAllCollectionLinks();
        rewriteInternalLinks();
        injectSneakerMenuItems();
      }
    });
    obs.observe(document.body, {childList:true, subtree:true});
  }

  function boot(){
    maybeShowModal();
    wireModal();
    wireSwitchers();
    decorateAllCollectionLinks();
    rewriteInternalLinks();
    attachFormFilters();
    filterCardsByTag();
    injectFloatingPill();
    injectSneakerMenuItems();
    observeForLateMenus();
  }

  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function(){
    decorateAllCollectionLinks(); rewriteInternalLinks(); attachFormFilters(); filterCardsByTag(); wireSwitchers();
  });
})();
